import Notice from './elements/notice'
import { get } from 'lodash';

const { no_access_desc } = get(
	window,
	'hubConnectorVars.texts',
	false
);

const NoAccess = () => {
	return (
		<main className="sui-wrap">
			<Notice style={{ marginBottom: '10px' }}>
				<p>{no_access_desc}</p>
			</Notice>
		</main>
	)
}

export default NoAccess
